import { render, staticRenderFns } from "./cerSignatureUpload.vue?vue&type=template&id=2f60fe58"
import script from "./cerSignatureUpload.vue?vue&type=script&lang=js"
export * from "./cerSignatureUpload.vue?vue&type=script&lang=js"
import style0 from "./cerSignatureUpload.vue?vue&type=style&index=0&id=2f60fe58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports